import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface buttonProps {
  active?: boolean;
}

export const Button = styled(Link)<buttonProps>`
  height: 34px;
  padding: 0 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  white-space: nowrap;

  text-decoration: none;

  border-radius: ${radius.sm};

  transition: color 0.2s, background-color 0.2s;

  ${props =>
    props.active
      ? css`
          background-color: ${colors.primary};
          color: ${colors.onPrimary};
        `
      : css`
          background-color: transparent;
          color: ${colors.onSurfaceVariant};

          &:hover {
            color: ${colors.onSurface};
          }
        `}

  span {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

export const ButtonNewTraining = styled.button`
  width: 34px;
  height: 34px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
  border: none;
  border-radius: ${radius.sm};
  cursor: pointer;

  color: ${colors.onSurfaceVariant};

  transition: color 0.2s;

  &:hover {
    color: ${colors.primary};
  }
`;

export const ContainerButtonsTrainings = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;

  flex: 1;
  overflow-x: auto;
`;

export const SplitTab = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const DeleteSplitButton = styled.button`
  flex-shrink: 0;
  padding: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
  border: none;
  border-radius: ${radius.sm};
  cursor: pointer;

  color: ${colors.error};

  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.error}1a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
